import { Box, Breakpoint, Button } from '@mui/material';
import { Modal } from '@vxui/components';
import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

export type ActionType = 'delete' | 'confirm' | 'none';

type ConfirmationDialogProps = {
  closeHandler: () => void;
  confirmHandler: () => void;
  open?: boolean;
  action?: ActionType;
  title?: string;
  cancel?: boolean;
  id?: string;
  maxWidth?: false | Breakpoint | undefined;
  fullWidth?: boolean;
};

export const ConfirmationDialog: FC<PropsWithChildren<ConfirmationDialogProps>> = ({
  children,
  closeHandler,
  confirmHandler,
  title,
  cancel = false,
  open = true,
  action = 'confirm',
  id,
  maxWidth = 'sm',
  fullWidth = true,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      id={id}
      title={title ?? t('modal.confirmation.title')}
      onClose={closeHandler}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      actions={
        action === 'none' ? (
          <Button variant="outlined" color="secondary" onClick={closeHandler}>
            {t('button.ok')}
          </Button>
        ) : (
          <>
            <Button variant="outlined" color="secondary" onClick={closeHandler} data-cy="confirmationModal_cancel">
              {cancel ? t('button.cancel') : t('button.close')}
            </Button>
            <Button
              variant="contained"
              color={action === 'delete' ? 'error' : 'secondary'}
              onClick={confirmHandler}
              sx={{ minWidth: '120px' }}
              data-cy="confirmationModal_ok"
            >
              {t(action === 'delete' ? 'button.delete' : 'button.ok')}
            </Button>
          </>
        )
      }
    >
      <Box>{children}</Box>
    </Modal>
  );
};
